import jss from 'jss';
import preset from 'jss-preset-default';
import $ from "jquery";
import "slick-carousel";
import { generateVectorPosition } from 'Client/utils/vector-position'
let widthDevice = window.innerWidth;
class WidgetOrganisations extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                slides: '#ecf-organisations .slides',
                slideItem: '#ecf-organisations .slides .slide',
            },
        };
    }
    getDefaultElements() {
        const selectors = this.getSettings('selectors');
        return {
            $slides: this.$element.find(selectors.slides),
            $slideItem: this.$element.find(selectors.slideItem),
        };
    }
    bindEvents() {
        let slides = this.elements.$slides[0];
        let slideItem = this.elements.$slideItem;
        if (slides) {
            $(slides).slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                infinite: false,
                arrows: true,
                variableWidth: true,
                nextArrow: '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next slick-arrow">Next</button>',
                prevArrow: '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev slick-arrow">Previous</button>',
                dots: false,
                // appendDots: $('.slick-slider-dots'),
                responsive: [{
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            infinite: false,
                            arrows: true,
                            variableWidth: true,
                            nextArrow: '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next slick-arrow">Next</button>',
                            prevArrow: '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev slick-arrow">Previous</button>',
                            dots: false,
                            arrows: true,
                        },
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: false,
                            nextArrow: true,
                            prevArrow: true,
                            // dots: true,
                            // appendDots: $('.slick-slider-dots'),
                            arrows: true,
                        },
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            variableWidth: false,
                            centerMode: true,
                            centerPadding: "16px",
                            // dots: true,
                            // appendDots: $('.slick-slider-dots'),
                            nextArrow: true,
                            prevArrow: true,
                            arrows: true,
                        },
                    },
                    {
                        breakpoint: 321,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: "16px",
                            // dots: true,
                            // appendDots: $('.slick-slider-dots'),
                            nextArrow: true,
                            prevArrow: true,
                            arrows: true,
                        },
                    },
                ],
            })
        }
    }
}

jQuery(window).on('elementor/frontend/init', () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(WidgetOrganisations, {
            $element,
        });
    };

    elementorFrontend.hooks.addAction('frontend/element_ready/ecf_organisations.default', addHandler);
});